import { IconClockQuestion, IconClockX, IconMicrophoneOff, IconMovieOff, IconMusicOff } from '@tabler/icons-react';

// "0:42", "5:18": a Reel's length as the platform shows it; null when unknown.
export const formatDuration = seconds => {
  if (seconds == null) return null;
  const total = Math.round(seconds);
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, '0')}`;
};

// Why a video cannot be chosen: the listing's `unavailable_reason`, or the `error_code` a
// failed mapping gave it (contract 2.3.0). Its glyph and the copy keys of the short label
// on the card and of the longer explanation in its tooltip.
export const UNAVAILABLE = {
  too_short: { icon: IconClockX, label: 'personalityReasonShort', hint: 'personalityReasonShortHint' },
  too_long: { icon: IconClockX, label: 'personalityReasonLong', hint: 'personalityReasonLongHint' },
  copyrighted_media: { icon: IconMusicOff, label: 'personalityReasonCopyright', hint: 'personalityReasonCopyrightHint' },
  duration_unknown: { icon: IconClockQuestion, label: 'personalityReasonUnknown', hint: 'personalityReasonUnknownHint' },
  insufficient_speech: { icon: IconMicrophoneOff, label: 'personalityReasonSpeech', hint: 'personalityReasonSpeechHint' },
  video_unavailable: { icon: IconMovieOff, label: 'personalityReasonUnavailable', hint: 'personalityReasonUnavailableHint' },
  video_out_of_range: { icon: IconClockX, label: 'personalityReasonRange', hint: 'personalityReasonRangeHint' },
};
export const unavailable = reason => UNAVAILABLE[reason] || UNAVAILABLE.video_unavailable;

// `limits.personality_video_min_seconds` / `_max_seconds`, for the copy that cites them.
export const personalityBounds = capabilities => {
  const limits = capabilities?.limits || {};
  return { seconds: limits.personality_video_min_seconds, minutes: Math.round(limits.personality_video_max_seconds / 60) };
};
